import React from 'react';
import { ILevelOfMyEvent } from '../../interface'
import { UiSectionTitle } from '../../../shared/components/ui/UiSectionTitle';


const LevelOfMyEvent = (props: ILevelOfMyEvent) => {

   const [firstLigne, ...autresLignes] = props.arrayValues;

   return (
      <div className="level-of-my-event">
         <p>Events' risk levels are categorized in two: Security and Safety Risk levels.</p>
         <p><strong>Security Risk Level</strong>: defined by different factors: country, total estimated values, certain types of assets involved.</p>
         <p><strong>Safety Risk Level</strong>: defined by the number of participants, if any hazardous activities are planned, type of location and the complexity of emergency response.</p>
         <div style={{ height: '16px' }} />
         <UiSectionTitle>Event Security Risk Level matrix:</UiSectionTitle>
         <p>For all Security Level 2 & 3 events, a <strong>declaration</strong> must be filled in the tool and a <strong>security concept</strong> must be created and uploaded.</p>
         <div className="box-content__table">
            <table className="table__level">
               <thead>
                  <tr>
                     {firstLigne.map((value, index) => <th key={index}>{value}</th>)}
                  </tr>
               </thead>
               <tbody>
                  {
                     autresLignes.map((ligne, indexLigne) => {
                        const [firstCol, ...restCol] = ligne
                        return (
                            <tr key={indexLigne}>
                                <td>{firstCol}</td>
                                {restCol.map((coloneValue, indexCol) => (
                                    <td key={indexCol}>
                                        {coloneValue && coloneValue === true && (
                                            <span className={"circle circle-" + indexCol}></span>
                                        )}
                                    </td>
                                ))}
                            </tr>
                        );
                     })
                  }
               </tbody>
            </table>
         </div>
         <div style={{ height: '32px' }} />
         <UiSectionTitle>Event Safety Risk Level:</UiSectionTitle>
         <p>For more information on Event Safety Risk Levels and Roles and Responsibilities please refer to Roles &amp; Responsibility: Event Safety.</p>
         <p><strong>LOW Event Safety Risk Level</strong></p>
         <p>A Low Safety Risk Level event is one where the environment, activities and number of people involved are predictable and well controlled. The likelihood of a safety incident is low and any foreseeable issues would be minor and manageable using standard procedures. These events can typically be delivered safely through routine planning and local oversight without the need for additional safety escalation.</p>
         <p><strong>MEDIUM Event Safety Risk Level</strong></p>
         <p>A Medium Safety Risk Level event is one where certain elements increase safety exposure and require deliberate management. These events may involve larger numbers of participants, less controlled environments, temporary infrastructure, or activities that carry inherent risk if controls fail. Safe delivery relies on structured safety planning, clearly defined responsibilities and active monitoring throughout the event lifecycle.</p>
         <p><strong>HIGH Event Safety Risk Level</strong></p>
         <p>A High Safety Risk Level event is one where the combination of scale, environment, activities, or emergency access constraints creates a realistic potential for serious injury, multiple casualties, or complex emergency response. These events require formal risk assessment, specialist safety input and robust mitigation measures. Delivery is subject to enhanced governance and approval, as failures could result in significant harm.</p>
      </div>
   );
}

export default LevelOfMyEvent